module.exports = __webpack_public_path__ + "img/login-bg.908fac5c.png";